import React from 'react';
import { useSelector } from 'react-redux';
import Loading from '../../components/Loading';
import OrderDetailsBAC from './OrderDetailsBAC';
import OrderDetailsOrganization from './OrderDetailsOrganization';

const OrderDetails = () => {
    const { user } = useSelector(state => state.auth);

    // Show loading while user is being fetched
    if (!user) {
        return <Loading fullHeight />;
    }

    // Route to BAC component for BAC users
    if (['root', 'bac-admin', 'bac-user'].includes(user.role)) {
        return <OrderDetailsBAC />;
    }

    // Route to Organization component for organization users
    if (['site-admin', 'site-user', 'site-guest'].includes(user.role)) {
        return <OrderDetailsOrganization />;
    }

    // Fallback for unknown roles
    return <Loading fullHeight />;
};

export default OrderDetails;
